<template>
	<div class="bg-F3F3F3">
		<!-- <headers bg="#000" color="#fff"></headers> -->
		<headers></headers>
		<div class="row stc-container body-height">
			<div class="col-md-8 p-4">
				<div class="tc-left-head cl-w flex justify-content-between">
					<div>
						<div class="">
							{{changeNum(convertToTimeZone(orderInfo.start_time).date.week)}}，
							{{convertToTimeZone(orderInfo.start_time).date.year}}{{ $t('teacherConfirms.year') }}
							{{convertToTimeZone(orderInfo.start_time).date.month}}{{ $t('teacherConfirms.month') }}
							{{convertToTimeZone(orderInfo.start_time).date.day}}{{ $t('teacherConfirms.day') }}（{{ timeZone}}）
						</div>
						<div class="ftr-1-5 mt-3">
							{{convertToTimeZone(orderInfo.start_time).date.hour}}:{{convertToTimeZone(orderInfo.start_time).date.minute}} /
							{{convertToTimeZone(orderInfo.finish_time).date.hour}}:{{convertToTimeZone(orderInfo.finish_time).date.minute}}
						</div>
					</div>
					<div class="br4 bg-w py-2 px-4 cl-theme" style="height: 40px;">
						{{ $t('statusConfirms.classId') }}{{formatNumber(orderInfo.id) }}
					</div>
				</div>
				<div class="bg-w pd16">
					<div class=" flex alcenter">
						<img :src="orderInfo.photo_image" alt="" class="photo-40" />
						<span class="ftr-1-25 ftw600 ml10">{{orderInfo.name}} {{orderInfo.surname}}</span>
					</div>
					<!-- <div class="mt-3">
						{{ $t('statusConfirms.courseName') }}: {{orderInfo.course_name}}
					</div> -->
					<div class="mt-4 flex">
						<div>
							<div class="ft14 cl-info">
								{{ $t('forClassIndex.class') }}
							</div>
							<div class="mt-2">
								{{orderInfo.course_name}}
							</div>
						</div>
						<div class="ms-5">
							<div class="ft14 cl-info">
								{{ $t('cashDesk.subject') }}
							</div>
							<div class="mt-2">
								初中-数学
							</div>
						</div>
						<div class="ms-5">
							<div class="ft14 cl-info">
								{{ $t('teacherConfirms.duration') }}
							</div>
							<div class="mt-2">
								50 min
							</div>
						</div>
						
					</div>
					<div class="mt-4 cl-info ft14">
						{{ $t('statusConfirms.languageCategory') }}
					</div>
					<div class="mt-2">
						{{ $t('statusConfirms.languageType') }}
					</div>
					<div class="mt-3 cl-info flex alcenter">
						<a-icon type="sound"></a-icon>
						<span class="ml10">{{ $t('statusConfirms.breakNote') }}</span>
					</div>
					<div v-if="orderInfo.confirmation_status==1">
						<hr class="mt-4" />
						<div class="ftr-1-25 ftw600">
							{{ $t('statusConfirms.contactToolSection') }}
						</div>
						<div class="flex alcenter mt-3">
							<img src="../../assets/image/commom/zoom.png" v-if="orderInfo.contact_way_text=='Zoom'" alt="" class="photo-40 br4" />
							<img src="../../assets/image/commom/voov.png" v-else alt="" class="photo-40 br4" />
							<div class="ml16"> {{orderInfo.contact_way_text}}</div>
							<div class="ms-5 text-center">
								<div class="cl-info ft12">
									{{ $t('statusConfirms.meetingId') }}
								</div>
								<div class="">
									{{orderInfo.contact_way_text=='Zoom'?orderInfo.contact_zoom_pmi:orderInfo.contact_voov_pmi}}
								</div>
							</div>
							<div class="ms-5 text-center">
								<div class="cl-info ft12">
									{{ $t('statusConfirms.password') }}
								</div>
								<div class="">
									<!-- 2468 -->
									{{orderInfo.contact_way_text=='Zoom'?orderInfo.contact_zoom_password:orderInfo.contact_voov_password}}
								</div>
							</div>
						</div>
						<div class="mt-4" v-if="orderInfo.teacher_entry_time">
							<span class="cl-info">{{ $t('statusConfirms.teacherEntryTime') }}</span>
							{{convertToTimeZone(orderInfo.teacher_entry_time).formattedTime }}
						</div>
						<div class="mt-3" v-if="orderInfo.user_entry_time">
							<span class="cl-info">{{ $t('statusConfirms.studentEntryTime') }}</span>
							{{convertToTimeZone(orderInfo.user_entry_time).formattedTime }}
						</div>
						<hr />
						<div >
							<div class="ftr-1-25 ftw600">
								{{ $t('statusConfirms.notes') }}
							</div>
							<div class="bg-F3F3F3 p-4 br12 flex mt-3 stc-wid-400" >
								<img src="../../assets/image/staduents/notes.png" alt="" style="width: 45px;height: 45px;" />
								<div class="ml15" style="width: 100%;">
									<div :class="index !=0? 'mt-3':''" v-for="(item,index) in orderInfo.reservation_order_appendix.status1">
										<div class="flex justify-content-between alcenter" >
											<a :href="item.file" class="cl-theme ftw600 text-line-none over-hide" style="width: 240px;"> {{item.name}}</a>
											<!-- <div class="cl-info ft14">
												17.4KB
											</div> -->
										</div>
										<div class="">
											{{convertToTimeZone(item.createtime).formattedTime}}
										</div>
										<div class="mt-2">
											{{item.remark}}
										</div>
									</div>
									<hr v-if="orderInfo.reservation_order_appendix.status1.length!=0" />
									<!-- <uploadFileVue @input="handleUplodeNotes">
										<div class="cl-theme ftr-1" :class="orderInfo.reservation_order_appendix.status1.length==0?'mt10':''">
											{{ $t('statusConfirms.uploadNotes') }}
										</div>
									</uploadFileVue> -->
									<div class="cl-theme ftr-1 clickAct" :class="orderInfo.reservation_order_appendix.status1.length==0?'mt10':''"
									@click="appendix_status = 1;openRemark = true">
										{{ $t('statusConfirms.uploadNotes') }}
									</div>
								</div>
							</div>
							<hr />
						</div>
						<div >
							<div class="ftr-1-25 ftw600">
								{{ $t('statusConfirms.homework') }}
							</div>
							<div class="bg-F3F3F3 p-4 br12 flex mt-3 stc-wid-400"  >
								<img src="../../assets/image/staduents/notes.png" alt="" style="width: 45px;height: 45px;" />
								<div class="ml15" style="width: 100%;"  >
									<div :class="index !=0? 'mt-3':''" v-for="(item,index) in orderInfo.reservation_order_appendix.status2">
										<div class="flex justify-content-between alcenter" >
											<a :href="item.file" class="cl-theme ftw600 text-line-none over-hide" style="width: 240px;"> {{item.name}}</a>
											<!-- <div class="cl-info ft14">
												17.4KB
											</div> -->
										</div>
										<div class="flex justify-content-between">
											<div class="">
												{{convertToTimeZone(item.createtime).formattedTime}},{{item.upload_status=='1'?$t('common.studentsUpload'):$t('common.teacherUpload')}}
											</div>
											<div class="cl-theme clickAct" @click="deleteAppendix(item.id)">
												{{$t('common.delete')}}
											</div>
										</div>
										<div class="mt-2">
											{{item.remark}}
										</div>
									</div>
									<hr v-if="orderInfo.reservation_order_appendix.status2.length!=0" />
									<!-- <uploadFileVue @input="handleUplode">
										<div class="cl-theme ftr-1" :class="orderInfo.reservation_order_appendix.status2.length==0?'mt10':''">
											{{ $t('statusConfirms.uploadHomework') }}
										</div>
									</uploadFileVue> -->
									<div class="cl-theme clickAct ftr-1" :class="orderInfo.reservation_order_appendix.status2.length==0?'mt10':''"
									@click="appendix_status = 2;openRemark = true">
										{{ $t('statusConfirms.uploadHomework') }}
									</div>
								</div>
							</div>
							<hr />
						</div>
						<div class="" >
							<div class="ftr-1-25 ftw600">
								{{ $t('statusConfirms.test') }}
							</div>
							<div class="bg-F3F3F3 p-4 br12 flex mt-3 stc-wid-400"  >
								<img src="../../assets/image/staduents/notes.png" alt="" style="width: 45px;height: 45px;" />
								<div class="ml15" style="width: 100%;">
									<div :class="index !=0? 'mt-3':''" v-for="(item,index) in orderInfo.reservation_order_appendix.status3">
										<div class="flex justify-content-between alcenter" >
											<a :href="item.file" class="cl-theme ftw600 text-line-none over-hide" style="width: 240px;"> {{item.name}}</a>
											<!-- <div class="cl-info ft14">
												17.4KB
											</div> -->
										</div>
										<div class="flex justify-content-between">
											<div class="">
												{{convertToTimeZone(item.createtime).formattedTime}},{{item.upload_status=='1'?$t('common.studentsUpload'):$t('common.teacherUpload')}}
											</div>
											<div class="cl-theme clickAct"  @click="deleteAppendix(item.id)">
												{{$t('common.delete')}}
											</div>
										</div>
										<div class="mt-2">
											{{item.remark}}
										</div>
									</div>
									<hr v-if="orderInfo.reservation_order_appendix.status3.length!=0"/>
									<!-- <uploadFileVue @input="handleUplodeTest">
										<div class="cl-theme ftr-1" :class="orderInfo.reservation_order_appendix.status3.length==0?'mt10':''">
											{{ $t('statusConfirms.uploadTest') }}
										</div>
									</uploadFileVue> -->
									<div class="cl-theme clickAct ftr-1" :class="orderInfo.reservation_order_appendix.status3.length==0?'mt10':''"
									@click="appendix_status = 3;openRemark = true">
										{{ $t('statusConfirms.uploadTest') }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-md py-4 pe-4">
				<div class="bg-w p-4 ">
					<div v-if="orderInfo.status==1&&orderInfo.confirmation_status==2&&orderInfo.order_type==2">
						<div class="text-center ftr-1-25" >
							{{ $t('statusConfirms.waitingStudentConfirm',{timeZone:timeZone}) }}
						</div>
						<div class="mt-3 cl-info">
							{{ $t('statusConfirms.waitingStudentConfirmClass') }}
						</div>
						<div class="mt-3 cl-info">
							{{$t('teacherConfirms.cancelReschedulePolicy')}}
						</div>
						<div>
							<a href="#" class="text-line-none" style="color: #49C4FF;"> {{ $t('statusConfirms.cancelAndReschedulePolicy') }} </a>
						</div>
					</div>
					<div v-if="orderInfo.status==1&&orderInfo.confirmation_status==2&&orderInfo.order_type==1">
						<div class="text-center ftr-1-25" >
							{{ $t('statusConfirms.waitingConfirm') }}
						</div>
						<div class="mt-3 cl-info">
							<!-- 課堂等待確認 -->
							
							{{$t('teacherConfirms.classPendingConfirm')}}
						</div>
						<div class="mt-3 cl-info">
							<!-- 如需取消或重新預約課時，請先閱讀我們的 -->
							{{$t('teacherConfirms.cancelReschedulePolicy')}}
						</div>
						<div>
							<a href="#" class="text-line-none" style="color: #49C4FF;"> {{ $t('statusConfirms.cancelAndReschedulePolicy') }} </a>
						</div>
					</div>
					<div v-if="orderInfo.status==1&&orderInfo.confirmation_status==1&&timeCompare(orderInfo.finish_time)!==1&& orderInfo.exception_status==1">
						<div class="text-center ftr-1-25" >
							{{ $t('statusConfirms.waitingClass') }}
						</div>
						<div class="mt-3 cl-info">
							{{$t('teacherConfirms.classStartOnTime')}}
						</div>
						<div class="mt-3 cl-info">
							{{$t('teacherConfirms.cancelReschedulePolicy')}}
						</div>
						<div>
							<a href="#" class="text-line-none" style="color: #49C4FF;"> {{ $t('statusConfirms.cancelAndReschedulePolicy') }} </a>
						</div>
					</div>
					<!-- 完课待确认 -->
					<div v-if="orderInfo.status==1&&orderInfo.confirmation_status==1&&timeCompare(orderInfo.finish_time)===1&&orderInfo.exception_status==1">
						<div class="text-center ftr-1-25" >
							{{ $t('statusConfirms.classCompletedConfirm') }}
						</div>
						<div class="mt-3 cl-info">
							{{ $t('statusConfirms.studentConfirm',{finish_time:getFinDate(convertToTimeZone( orderInfo.finish_time).formattedTime,3),timeZone:timeZone}) }}
							
							<!-- 學生將在課程結束後的 3 天內確認，否則系統將在{{orderInfo.finish_time}} (UTC+08:00) 自動確認課程。 -->
						</div>
					</div>
					<!-- 恭喜，本節课程已完成 -->
					<div v-if="orderInfo.status==2&&orderInfo.exception_status!=2">
						<div class="text-center ftr-1-25" >
							{{ $t('statusConfirms.classCompleted') }}
						</div>
						<div class="mt-3 cl-info">
							{{$t('teacherConfirms.classCompletedCongrats')}}
						</div>
					</div>
					<!-- 课程已取消 -->
					<div v-if="orderInfo.status==3">
						<div class="text-center ftr-1-25" >
							{{$t('common.courseCancelled')}}
						</div>
					</div>
					<!-- 课程未完成 -->
					<div v-if="orderInfo.exception_status==2&&orderInfo.platform_status==1">
						<div class="" v-if="!orderInfo.reservation_order_exception.result || orderInfo.reservation_order_exception.result==0">
							<div class="text-center ftr-1-25" >
								{{ $t('statusConfirms.courseNotCompleted') }}
							</div>
							<div class="mt-3 cl-info">
								{{ $t('statusConfirms.studentMarkedNotCompleted', { time: getFinDate(convertToTimeZone( orderInfo.finish_time).formattedTime,3) ,timeZone:timeZone }) }}
							</div>
							<div class="mt-3 cl-info">
								{{ $t('statusConfirms.notCompletedReason', { reason: orderInfo.reservation_order_exception.reason, expectedResult: orderInfo.reservation_order_exception.expected_result }) }}
							</div>
							<div class="mt-3 cl-info">
								{{ $t('statusConfirms.content', { content: orderInfo.reservation_order_exception.content }) }}
							</div>
							<div class="mt-2 flex wrap">
								<div class="" v-for="(item,index) in orderInfo.reservation_order_exception.files_list">
									<img :src="item" alt="" style="width: 60px;height: 60px;margin: 2px;" 
									@click="viewImg = item;visibleView = true"/>
								</div>
								
							</div>
							<button type="button" class="btn btn-theme mt-3 wid-100" @click="isResolved = true"> {{ $t('statusConfirms.resolved') }}</button>
							<button type="button" class="btn btn-light mt-3 wid-100" @click="isUnresolved = true"> {{ $t('statusConfirms.unresolved') }}</button>
						</div>
						<div v-if="orderInfo.reservation_order_exception.result&&orderInfo.reservation_order_exception.status!=3&&orderInfo.reservation_order_exception.result!=0">
							<div class="text-center ftr-1-25" >
								<!-- 課程未完成處理結果確認 -->
								{{$t('teacherConfirms.classNotCompletedResultConfirm')}}
							</div>
							<div class="mt-3 cl-info ">
								
								{{$t('statusConfirms.processWithin48Hours',{time: getFinDate(convertToTimeZone( orderInfo.finish_time).formattedTime,2) ,timeZone:timeZone})}}
								<!-- 請在48小時內 {{orderInfo.finish_time}} (UTC+08:00) 前處理。 -->
							</div>
							<div class="mt-4 flex">
								<span class="cl-info">{{ $t('statusConfirms.teacherhandlingplan') }}：</span>
								
								<span v-if="orderInfo.reservation_order_exception.result=='1'">{{$t('statusConfirms.result1')}}</span>
								<span v-if="orderInfo.reservation_order_exception.result=='2'">{{$t('statusConfirms.result2')}}</span>
								<span v-if="orderInfo.reservation_order_exception.result=='3'">{{$t('statusConfirms.result3')}}</span>
							</div>
							<div class="mt-2"v-if="orderInfo.reservation_order_exception.result==3">
								<span class="cl-info">{{ $t('statusConfirms.refundAmount') }}：</span>${{getCurrency()}}
								{{convertCurrency(orderInfo.reservation_order_exception.money)}}
							</div>
							
						</div>
						<div v-if="orderInfo.reservation_order_exception.status==3">
							<div class="text-center ftr-1-25" >
								{{ $t('statusConfirms.classNotCompleted') }}
							</div>
							<div class="mt-4">
								<span class="cl-info">{{ $t('statusConfirms.teacherhandlingplan') }}：</span>
								<span v-if="orderInfo.reservation_order_exception.result=='1'">{{$t('statusConfirms.result1')}}</span>
								<span v-if="orderInfo.reservation_order_exception.result=='2'">{{$t('statusConfirms.result2')}}</span>
								<span v-if="orderInfo.reservation_order_exception.result=='3'">{{$t('statusConfirms.result3')}}</span>
							</div>
							<div class="mt-2" v-if="orderInfo.reservation_order_exception.result==3">
								<span class="cl-info">{{ $t('statusConfirms.refundAmount') }}：</span>${{getCurrency()}} 
								{{convertCurrency(orderInfo.reservation_order_exception.money)}}
							</div>
						</div>
					</div>
					<!-- 等待平台裁决 -->
					<div v-if="orderInfo.platform_status==2&&orderInfo.exception_status==2">
						<div class="text-center ftr-1-25" >
							{{ $t('statusConfirms.waitingPlatformDecision') }}
						</div>
						<div class="mt-3 cl-info">
							<!-- 請等待平台處理 -->
							{{$t('teacherConfirms.pleaseWaitPlatform')}}
						</div>
					</div>
					<!-- 确认老师发起的课程 -->
					<button type="button" class="btn btn-theme mt-3 wid-100" 
					@click="confirmationOrder()"
					v-if="orderInfo.status==1&&orderInfo.order_type==1&&timeCompare(orderInfo.start_time)===2&&orderInfo.confirmation_status==2">
						{{ $t('statusConfirms.confirmCourse') }}
					</button>
					<!-- 订单未确认 -->
					<button type="button" class="btn btn-light mt-3 wid-100"
						@click="cancelOrder()"
						v-if="orderInfo.status==1&&orderInfo.confirmation_status==2">
						{{ $t('statusConfirms.cancelClass') }}
					</button>
					<div v-if="orderInfo.status==1&&orderInfo.confirmation_status==1&&timeCompare(orderInfo.finish_time)!==1&& orderInfo.exception_status==1">
						<button type="button" class="btn btn-theme mt-3 wid-100"
						v-if="showEnterClassRoom(orderInfo.start_time,orderInfo.finish_time)"
						 @click="enterClassroom"> {{ $t('statusConfirms.enterClassroom') }}</button>
						<div class="mt-2 cl-theme text-center"
						v-if="showEnterClassRoom(orderInfo.start_time,orderInfo.finish_time)">
							{{ $t('statusConfirms.reenterNote') }}
						</div>
						<button type="button" class="btn btn-light mt-3 wid-100"
							@click="cancelOrder()">
							{{ $t('statusConfirms.cancelClass') }}
						</button>
					</div>
					
				</div>
			</div>
		</div>
		<!-- 報告課程未完成 -->
		<div class="" v-if="isCourseCompleted">
			<courseNotCompleted :visible="isCourseCompleted" @cancel="isCourseCompleted = false" :order_id="Number(order_id)"
			@confirm="isCourseCompleted = false;getOrderDetail()"></courseNotCompleted>
		</div>
		<div class="" v-if="isResolved">
			<resolved :visible="isResolved" :order_id="Number(order_id)"
			 @cancel="isResolved = false" @confirm="isResolved = false;getOrderDetail()"></resolved>
		</div>
		<div class="" v-if="isUnresolved">
			<unresolved :visible="isUnresolved" @cancel="isUnresolved = false"
			:order_id="Number(order_id)" @confirm="isUnresolved = false;getOrderDetail()"></unresolved>
		</div>
		<a-modal title="" :width="650" :visible="visibleView" @cancel="handleCancelView" :closable="false" :footer="null">
			<img :src="viewImg" alt="" style="width: 100%;" />
		</a-modal>
		
		<div v-if="openRemark">
			<upload-file-remark :visible="openRemark" :order_id="Number(order_id)" :status="appendix_status" :is_teacher="true"
			 @cancel="openRemark = false" @ok="openRemark = false;getOrderDetail()"></upload-file-remark>
		</div>
		
		<footers></footers>
	</div>
</template>

<script>
	import courseNotCompleted from "./components/courseNotCompleted.vue"
	import teacherEvaluation from "./components/teacherEvaluation.vue"
	import resolved from "./components/resolved.vue"
	import unresolved from "./components/unresolved.vue"
	import uploadFileVue from "../../components/upload/upload_file.vue"
	import uploadFileRemark from "../../components/upload/upload_file_remark.vue"
	
	export default{
		components:{
			courseNotCompleted,
			teacherEvaluation,
			resolved,
			unresolved,
			uploadFileVue,
			uploadFileRemark
		},
		data(){
			return{
				isCourseCompleted:false,
				isTeacher:false,
				isResolved:false,
				isUnresolved:false,
				order_id:0,
				orderInfo:{},
				visibleView:false,
				viewImg:'',
				file:'',
				timeZone:localStorage.getItem('timeZone'),
				
				openRemark:false,
				appendix_status:1,//附录类型:1=笔记,2=作业,3=测验,学生不传1
			}
		},
		created(){
			this.order_id = this.$route.query.id
			this.getOrderDetail()
		},
		methods:{
			formatNumber(num) {
			    // 将输入转换为字符串
			    let numStr = num.toString();
			    
			    // 如果数字长度超过6位，直接返回 L + 数字
			    if (numStr.length >= 6) {
			        return 'L' + numStr;
			    }
			
			    // 否则，补充0到6位
			    let paddedNum = numStr.padStart(6, '0');
			    return 'L' + paddedNum;
			},
			handleUplodeTest(e) {
				this.file = e.file;
				this.uploadAppendix(3,e.name);
			},
			handleUplode(e) {
				this.file = e.file;
				this.uploadAppendix(2,e.name);
			},
			handleUplodeNotes(e) {
				console.log("-------------",e);
				this.file =e.file;
				this.uploadAppendix(1,e.name);
			},
			uploadAppendix(status,name) {
				this.$http.api('teacher/reservation/uploadAppendix', {
					order_id: this.order_id,
					status: status,
					file: this.file,
					name
				}).then(res => {
					this.file = '';
					this.$message.success(this.$t('teacherConfirms.operationSuccess'), 1,
						() => {
							this.getOrderDetail();
						});
				});
			},
			handleCancelView(){
				this.visibleView = false
			},
			getFinDate(str,num){
				let date = new Date(str);
				
				// 增加三天
				date.setDate(date.getDate() + num);
				let year = date.getFullYear();
				let month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1
				let day = String(date.getDate()).padStart(2, '0');
				let hours = String(date.getHours()).padStart(2, '0');
				let minutes = String(date.getMinutes()).padStart(2, '0');
				let seconds = String(date.getSeconds()).padStart(2, '0');
				
				// 格式化输出
				let formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
				return formattedDate;
				// 输出结果
				// console.log(date);
			},
			
			timeCompare(time){
				const currentTime = new Date();
				
				// 传入的目标时间
				const targetTime = new Date(time);
				
				// 比较当前时间和目标时间
				if (currentTime < targetTime) {
					// start_time>当前时间可调用 订单确认条件
					
				    console.log('当前时间早于目标时间');
					return 2
				} else if (currentTime > targetTime) {
					// finish_time<当前时间
				    console.log('当前时间晚于目标时间');
					return 1
				} else {
				    console.log('当前时间等于目标时间');
					return false
				}
			},
			// 取消课堂
			cancelOrder(){
				this.$confirm({
					title: this.$t('teacherConfirms.confirmCancel'),
					content:  this.$t('teacherConfirms.cancelClassText'),
					okText: this.$t('teacherConfirms.confirmAction'),
					okType: "danger",
					cancelText: this.$t('teacherConfirms.cancelAction'),
					okButtonProps: {
					    style: { backgroundColor: '#52C4C9',borderColor:'#52C4C9', color: 'white' } // 设置确认按钮颜色
					  },
					onOk: () => {
						this.$http.api('teacher/reservation/cancelOrder',{
							order_id:this.orderInfo.id
						}).then(res=>{
							this.$message.success(this.$t('teacherConfirms.operationSuccess'),1,()=>{
								this.getOrderDetail()
							})
						})
					},
					onCancel: () => {
						console.log("Cancel");
					},
				});
				
			},
			
			// 订单确认
			confirmationOrder(){
				this.$http.api('teacher/reservation/confirmationOrder',{
					order_id:this.order_id
				}).then(res=>{
					this.$message.success(this.$t('teacherConfirms.operationSuccess'),1,()=>{
						this.getOrderDetail()
					})
				})
			},
			//判斷是否顯示進入教室按鈕
			showEnterClassRoom(startTime, endTime) {
				const currentTime = new Date();
				const start = new Date(startTime);
				const end = new Date(endTime);
				// 计算开始时间前10分钟
				const startTenMinutesBefore = new Date(start.getTime() - 10 * 60 * 1000);
				// 计算结束时间后5分钟
				const endFiveMinutesAfter = new Date(end.getTime() + 5 * 60 * 1000);
			
				return currentTime >= startTenMinutesBefore && currentTime <= endFiveMinutesAfter;
			},
			// 进入教室
			enterClassroom(){
				this.$http.api('teacher/reservation/enterClassroom',{
					order_id:this.order_id
				}).then(res=>{
					this.$message.success(this.$t('teacherConfirms.operationSuccess'),1,()=>{
						this.getOrderDetail()
						 window.open(res.url, '_blank');
					})
				})
			},
			// 确认课程
			accomplishOrder(){
				this.$http.api('teacher/reservation/accomplishOrder',{
					order_id:this.order_id
				}).then(res=>{
					this.$message.success(this.$t('teacherConfirms.operationSuccess'),1,()=>{
						this.getOrderDetail()
					})
				})
			},
			getOrderDetail(){
				this.$http.api('teacher/reservation/orderDetail',{
					order_id:this.order_id
				}).then(res=>{
					this.orderInfo = res.info
				})
			}
		}
	}
</script>

<style>
	.tc-left-head{
		padding: 16px;
		background: linear-gradient( 90deg, #02CAB9 0%, #0DD0C0 50%, #5AF9EE 100%);
	}
	.stc-wid-400{
		width: 400px;
	}
	@media (max-width:575.98px) {
		.stc-container {
			margin: auto;
			width: 100%;
			padding-left: 1.5rem !important;
			padding-right: 1.5rem !important;
		}
		.stc-wid-400{
			width: 100% !important;
		}
	}
	@media (min-width: 576px) {
		.stc-container {
			margin: auto;
			width: 580px;
		}
	
	}
	
	@media (min-width: 768px) {
		.stc-container {
			margin: auto;
			width: 700px;
		}
	}
	@media (min-width: 992px) {
		.stc-container {
			margin: auto;
			width: 900px;
		}
	}
	@media (min-width: 1200px) {
		.stc-container {
			margin: auto;
			width: 1100px;
		}
	}
	
	@media (min-width: 1400px) {
		.stc-container {
			margin: auto;
			width: 1300px;
		}
	}
</style>